module.exports = __webpack_public_path__ + "media/images/logo-a399d8a3ec549a1a130f38150ce18cbc.png";